import { UserSearchDTO } from 'entities/user';

export const getUsersIds = (data: UserSearchDTO[]): string[] => {
  const usersId: string[] = [];
  data.forEach((item) => {
    usersId.push(item.id);
  });
  return usersId;
};
